var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72273 12.0916H6.74691C9.90382 12.0916 12.4696 14.6548 12.4696 17.8143V19.961C12.4696 20.4205 12.0962 20.7912 11.6394 20.7912H1.8302C1.37077 20.7912 1 20.4178 1 19.961V17.8143C1 14.6574 3.56314 12.0916 6.72273 12.0916Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63406 9.50646C7.88939 9.50646 8.90703 8.48881 8.90703 7.23348C8.90703 5.97816 7.88939 4.96051 6.63406 4.96051C5.37873 4.96051 4.36108 5.97816 4.36108 7.23348C4.36108 8.48881 5.37873 9.50646 6.63406 9.50646Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71313 12.9218C10.3472 10.4527 12.5879 8.63113 15.2532 8.63113H15.2774C18.4369 8.63113 21.0001 11.1916 21.0001 14.3539V16.5006C21.0001 16.96 20.6266 17.3308 20.1699 17.3308H11.8706",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1697 6.04595C16.425 6.04595 17.4427 5.0283 17.4427 3.77297C17.4427 2.51765 16.425 1.5 15.1697 1.5C13.9144 1.5 12.8967 2.51765 12.8967 3.77297C12.8967 5.0283 13.9144 6.04595 15.1697 6.04595Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.fc392050.svg";
export { ForwardRef as ReactComponent };